import * as types from './types'
import { attachmentsServices } from '@/_services'
import i18n from '@/i18n'


const actions = {
  setListAttachments({ commit }, { resource, resourceID }) {
    commit(types.IS_FETCHING, { flag: true })
    commit(types.SET_LIST_ATTACHMENTS, { listAttachments: null })
    attachmentsServices.listAttachments({ resource, resourceID  })
    .then((attachments) => {
      commit(types.SET_LIST_ATTACHMENTS, { listAttachments: attachments })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.IS_FETCHING, { flag: false })
    })
  },
  setListAttachmentsAfterUpload({ commit }, { resource, resourceID }) {
    attachmentsServices.listAttachments({ resource, resourceID  })
    .then((attachments) => {
      commit(types.SET_LIST_ATTACHMENTS, { listAttachments: attachments })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.IS_FETCHING, { flag: false })
    })
  },
  uploadRequest({ commit, dispatch }, { file, filename, resource, resourceID  }) {
    commit(types.IS_UPLOADING, { flag: true })
    attachmentsServices.uploadAttachmentFile({ file, filename, resource, resourceID })
    .then(() => {
      dispatch('showSnackbar', { message: i18n.t('snackbars.uploaded_attachment'), color: 'success' }, { root: true })
      dispatch('attachments/setListAttachmentsAfterUpload', { resource, resourceID }, { root: true })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.IS_UPLOADING, { flag: false })
    })
  },
  downloadRequest({ commit }, { s3Key, filename }) {
    commit(types.IS_DOWNLOADING, { flag: s3Key })
    attachmentsServices.downloadAttachmentFile({ s3Key })
    .then((download) => {
      console.log(filename)
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.IS_DOWNLOADING, { flag: false })
    })
  },
  deleteAttachment({ commit, dispatch }, { s3Key }) {
    commit(types.REMOVE_ATTACHMENT, { s3Key })
    attachmentsServices.deleteAttachmentFile({ s3Key })
    .then(() => {
      dispatch('showSnackbar', { message: i18n.t('snackbars.delete_attachment'), color: 'success' }, { root: true })
    })
    .catch((error) => {
      console.log(error)
    })
  }
}

export default actions
